import { CombinedQuestionStats } from "../view-survey.types";
import { useMemo } from "react";
import { AnswerSource } from "../../../redux/survey/survey.types";
import { maxAnswerPercentage, sortAnswers } from "./results-question.helpers";

/** Always use All; AI/Human toggle removed - unified results only */
export const useResultsQuestion = (question: CombinedQuestionStats, _aiMaxCompletes?: number, _humanMaxCompletes?: number) => {
  const { answers, freeformAnswers } = question;
  const hasImageAnswers = answers.some(answer => answer.imageUrl);
  const answerFilter = AnswerSource.All;
  const showFilters = false;

  const { maxPercentage, sortedAnswers } = useMemo(() => {
    const sorted = question.freeformAnswers === undefined ? sortAnswers(answers, answerFilter) : [];
    return { maxPercentage: maxAnswerPercentage(answers, answerFilter), sortedAnswers: sorted };
  }, [answers, question.freeformAnswers]);

  return { hasImageAnswers, answerFilter, showFilters, maxPercentage, sortedAnswers, freeformAnswers };
};
